import UserProfile from '../../../components/UserProfile';
import { useAchievementUser } from '../achievementQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const AchievementUserProfile = ({
  publicId
}) => {
  const user = useAchievementUser(publicId);
  if (!user) return null;
  return /*#__PURE__*/_jsx(UserProfile, {
    avatarHash: user.avatarHash,
    firstName: user.firstName,
    lastName: user.lastName
  });
};
export default AchievementUserProfile;